module.exports = new __parcel__URL__("recruitment_ko.5935c38a.webp").toString();